import CryptoJS from 'crypto-js'

// Possibly pass through .env if needed.
const LOCK_KEY = 'encrypt-key'

export const encrypt = (value: string) => {
  return CryptoJS.AES.encrypt(value, LOCK_KEY).toString()
}

export const decrypt = (value?: string) => {
  if (!value) {
    return value
  }

  return CryptoJS.AES.decrypt(value, LOCK_KEY).toString(CryptoJS.enc.Utf8)
}
